import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';

export const useUpdateDriverStatus = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (status: string) => {
      const token = await getAccessTokenSilently();
      driverApi.setAuthToken(token);
      return driverApi.updateDriverStatus(status);
    },
    onSuccess: () => {
      // Invalidate and refetch driver profile and calls to get updated data
      queryClient.invalidateQueries({ queryKey: ['driver-profile'] });
      queryClient.invalidateQueries({ queryKey: ['driver-calls'] });
    },
    onError: (error) => {
      console.error('Failed to update driver status:', error);
    },
  });
};
